import { Autocomplete, FormControl, ListItemIcon, ListItemText, MenuItem, TextField } from '@mui/material';
import { NShiftPartnerService } from 'models/nshift-partners';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';

type NShiftPartnerServicesAutoCompleteProps = {
    nShiftPartnerServices: NShiftPartnerService[];
    onServiceSelect: (service: NShiftPartnerService) => void;
};

const NShiftPartnerServicesAutoComplete: FC<NShiftPartnerServicesAutoCompleteProps> = ({
    nShiftPartnerServices,
    onServiceSelect,
}: NShiftPartnerServicesAutoCompleteProps) => {
    const { t: translate } = useTranslation(['transport', 'orders']);
    const [inputValue, setInputValue] = useState('');

    const handleServiceSelect = (_: React.SyntheticEvent, service: NShiftPartnerService | any) => {
        setInputValue('');
        onServiceSelect(service);
    };

    return (
        <FormControl fullWidth>
            <Autocomplete
                fullWidth
                disableClearable
                options={nShiftPartnerServices}
                sx={{ minWidth: 300 }}
                id="nshift-partner-service-label"
                inputValue={inputValue}
                noOptionsText={translate('orders:TYPE_TO_SEARCH')}
                getOptionLabel={(option: NShiftPartnerService | string) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option.description} (${option.id})`;
                }}
                renderOption={(props, option: NShiftPartnerService) => (
                    <MenuItem {...props} key={option.id} value={option.id}>
                        <ListItemIcon>
                            <AddIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>
                            {option.description} ({option.id})
                        </ListItemText>
                    </MenuItem>
                )}
                onChange={handleServiceSelect}
                renderInput={(params) => <TextField {...params} label={translate('transport:SELECT_SERVICES')} />}
                isOptionEqualToValue={(option: NShiftPartnerService, value: NShiftPartnerService) =>
                    option.id === value.id
                }
                onInputChange={(_, value, reason) => {
                    if (reason === 'reset') {
                        setInputValue('');
                        return;
                    }
                    setInputValue(value);
                }}
            />
        </FormControl>
    );
};

export default NShiftPartnerServicesAutoComplete;
